import { Injectable } from '@angular/core';
import { Workbook } from 'exceljs';
import * as fs from 'file-saver';


@Injectable()
export class ExcelExportService {

    constructor() { }



    generateExcel(xlData: any, fileName: string): Promise<void> {
        console.log("Xl Datatattattataattatta====",xlData);
        const sheets: any = Object.keys(xlData);
        console.log("Xl sheets====",sheets);

        if (!sheets || sheets.length === 0) {
            return Promise.resolve();
        }

        const workbook = new Workbook();
        return new Promise<void>((resolve, reject) => {
        sheets.forEach((sheetName: any, i: number) => {
            const sheetInfo = xlData[sheetName];
            const title = sheetInfo.title ? sheetInfo.title : '';
            const subtitle = sheetInfo.subtitle ? sheetInfo.subtitle : '';
            const data = sheetInfo.data;
            const header = sheetInfo.header ? sheetInfo.header : '';
            const footer = sheetInfo.footer ? sheetInfo.footer : '';
            const mergeCells = sheetInfo.mergeCells ? sheetInfo.mergeCells : '';
            const dataDivider = sheetInfo.dataDivider ? sheetInfo.dataDivider : '';
            const customizedData = sheetInfo.customizedData ? sheetInfo.customizedData : '';
            const imageData = sheetInfo.images ? sheetInfo.images : '';

            // Create workbook and worksheet
            const worksheet = workbook.addWorksheet(sheetName);

            // Add Row and formatting
            if (title != '') {
                const titleRow = worksheet.addRow([title.title]);
                titleRow.font = title.font;
                titleRow.alignment = title.alignment ? title.alignment : { horizontal: 'center' };//add newly
                if (title.fill) {
                    titleRow.eachCell((cell) => {
                        cell.fill = title.fill;
                    });
                }
                if (!title.skipBlankRow) {
                    worksheet.addRow([]);
                }
                if (title.subTitleRow) { worksheet.addRow([title.subTitleRow]); }
                if (title.mergeCells) { worksheet.mergeCells(title.mergeCells); }
            }


            if (subtitle != '') {
                if (subtitle.subTitleRow) {
                    worksheet.addRow([]);
                    const subtitleRow = worksheet.addRow(subtitle.subTitleRow);
                    if (subtitle.font) subtitleRow.font = subtitle.font;
                }
                if (subtitle.mergeCells) { worksheet.mergeCells(subtitle.mergeCells); }
            }


            if (header != '') {
                // Blank Row
                // worksheet.addRow([]);
                // Add Header Row

                const headerRow = worksheet.addRow(header.headers);
                headerRow.alignment = header.alignment ? header.alignment : { horizontal: 'center' };//add newly
                // Cell Style : Fill and Border
                headerRow.eachCell((cell, number) => {
                    if (header.fill) { cell.fill = header.fill; }
                    if (header.font) { cell.font = header.font; }
                    if (header.border) { cell.border = header.border; }
                });
            }

            // Add Subtitle row for additional informaion

            console.log("data==========",data)

            if (data.data) {
                // Add Data and Conditional Formatting
                data.data.forEach(d => {
                    if (dataDivider == '') {
                        const row = worksheet.addRow(d);
                    }
                    if (dataDivider) {
                        const row = worksheet.addRow(d['data'])
                        if (d['mergeCells']) worksheet.mergeCells(d['mergeCells'])
                    }
                });
            }

            if (data.columWith) {
                data.columWith.forEach(col => {
                    worksheet.getColumn(col.colNo).width = col.width;
                });
            }

            if (mergeCells != '') {
                mergeCells.forEach(element => {
                    try {
                        worksheet.mergeCells(element)
                    }
                    catch (err) {
                        console.log(err);
                    }
                });
            }

            if (customizedData != '') {
                customizedData.forEach((rowVal: any) => {

                    const row = worksheet.addRow(rowVal.value);

                    if (rowVal.mergeCells) {
                        try {
                            if (!Array.isArray(rowVal.mergeCells)) rowVal.mergeCells = [rowVal.mergeCells];
                            rowVal.mergeCells.forEach(element => {
                                try {
                                    worksheet.mergeCells(element)
                                }
                                catch (err) {
                                    console.log(err);
                                }
                            });
                        }
                        catch (err) {
                            console.log(err);
                        }
                    }

                  
                    if (rowVal?.alignment) {
                        if (!Array.isArray(rowVal.alignment)) {
                            rowVal.alignment = [rowVal.alignment];
                        }

                        rowVal.alignment.forEach((element) => {
                            if (element?.cell && element?.value) {
                                const cell = worksheet.getCell(element.cell);

                                // Set alignment
                                cell.alignment = element.value;
                            }
                        });
                    } else {
                    }

                    if (rowVal?.height) {
                        row.height = rowVal.height;
                    }
                    // if (rowVal?.alignment) {
                    //     if (!Array.isArray(rowVal.alignment)) {
                    //         rowVal.alignment = [rowVal.alignment]; // Wrap it in an array if it's not already one
                    //     }

                    //     rowVal.alignment.forEach(element => {
                    //         if (element?.cell && element?.value) {
                    //             worksheet.getCell(element.cell).alignment = element.value;
                    //         }
                    //     });
                    // }

                    if (rowVal.font) {
                        row.font = rowVal.font;
                    }

                    if (rowVal.cellConfig) {
                        if (rowVal.cellConfig.cells) {
                            if (!Array.isArray(rowVal.cellConfig.cells)) rowVal.cellConfig.cells = [rowVal.cellConfig.cells];
                            rowVal.cellConfig.cells.forEach(element => {

                                if (element.value !== undefined) worksheet.getCell(element.cell).value = element.value;
                                if (element.font) worksheet.getCell(element.cell).font = element.font;
                                if (element.fill) worksheet.getCell(element.cell).fill = element.fill;
                                if (element.border) worksheet.getCell(element.cell).border = element.border;
                                if (element.alignment) worksheet.getCell(element.cell).alignment = element.alignment;
                            });
                        }
                    }

                    row.eachCell((cell, number) => {
                        if (rowVal.fill) { cell.fill = rowVal.fill; }
                        if (rowVal.border) { cell.border = rowVal.border; }
                    });

                });
            }

            worksheet.addRow([]);

            // Footer Row
            if (footer != '') {
                const footerRow = worksheet.addRow([footer.text]);
                footerRow.getCell(1).fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'FFCCFFE5' }
                };
                footerRow.getCell(1).border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
                // Merge Cells
                worksheet.mergeCells(`A${footerRow.number}:F${footerRow.number}`);
            }

            if (imageData && imageData.length > 0) {
                imageData.forEach((image) => {
                    const imageData = image.data;
                    const excelRefImage = workbook.addImage(imageData);  //imageData = { base64: "base64string", extension: 'png', }
                    worksheet.addImage(excelRefImage, image.cell);  // image.cell = 'B12:D12'
                })
            }

            if (sheets.length - 1 == i) {
                // Generate Excel File with given name
                workbook.xlsx.writeBuffer().then((data: any) => {
                    const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                    fs.saveAs(blob, fileName);
                    resolve();
                }).catch((err) => {
                    console.log(err);
                    reject(err);
                });
            }

        });
        });


    }
}
